/* istanbul ignore next */
if (typeof rcm != 'undefined') {
    rcm.addAngularModule('rcm-ui');
}
angular.module('rcm-ui', ['pipe-rat-js']);
